<template>
    <div class="bidder-flow-page">
        <div class="main-workflow">
            <div class="project-flow-toolbar">
                <div class="project-flow-toolbar__meta">
                    <h2 class="project-flow-toolbar__title">
                        {{ projectTitle }}
                    </h2>
                    <div v-if="bidSectionName" class="project-flow-toolbar__section">
                        <span class="project-flow-toolbar__section-label">标段名称</span>
                        <span class="project-flow-toolbar__section-value">{{ bidSectionName }}</span>
                    </div>
                </div>
                <!-- <div class="toolbar-actions">
                    <el-button 
                        type="warning" 
                        icon="el-icon-download" 
                        @click="downloadDialogVisible = true"
                        class="project-flow-toolbar__download-btn"
                    >
                        下载投标客户端
                    </el-button>
                    <el-button type="primary" icon="el-icon-back" @click="handleBack" class="project-flow-toolbar__back">
                        返回
                    </el-button>
                </div> -->
            </div>
            <div class="workflow-stage main-stage">
                <div v-for="(stage, index) in mainTitles" :key="`main-${index}`" class="workflow-item">
                    <img :src="stage.leftImage" :alt="`${stage.name}`" class="decoration-image" />
                    <div class="content-wrapper">
                        <div class="content"
                            :style="{ backgroundColor: stage.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            style="border-radius: 0px;   box-shadow: 0 2px 4px rgba(0, 0, 0, 0);">{{ stage.name }}</div>
                        <div class="content-overlay"></div>
                    </div>
                    <img :src="stage.rightImage" :alt="`${stage.name}`" class="decoration-image" />
                </div>
            </div>

            <!-- 第一阶段：报名与资料 -->
            <div class="workflow-stage">
                <div class="workflow-item" v-for="value in mainStages" :key="value.id" @click="handleStageClick(value)"
                    :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" alt="" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === value.name ? require('@/assets/image/bidProProcess-hover-after.png') : (value.colorClass == 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content" :class="{ 'pulse-animation': value.id === 103 && value.status === 0 }"
                            :style="{ backgroundColor: value.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">
                            {{ value.id === 103 && value.status === 0 ? '未制作投标文件' : value.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" alt="" class="stage-decoration hidden" />
                </div>
            </div>

            <!-- 第二阶段：投标与开标 -->
            <div class="workflow-stage">
                <div class="workflow-item" v-for="value in secondaryStages" :key="value.id"
                    @click="handleStageClick(value)" :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" alt="" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === value.name ? require('@/assets/image/bidProProcess-hover-after.png') : (value.colorClass == 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content" :class="{ 'pulse-animation': value.id === 203 && value.status === 0 }"
                            :style="{ backgroundColor: value.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">
                            {{ value.id === 203 && value.status === 0 ? '未缴纳技术服务费' : value.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" alt="" class="stage-decoration hidden" />
                </div>
            </div>

            <!-- 第三阶段：结果与我的 -->
            <div class="workflow-stage">
                <div class="workflow-item" v-for="value in resultStages" :key="value.id"
                    @click="handleStageClick(value)" :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" alt="" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === value.name ? require('@/assets/image/bidProProcess-hover-after.png') : (value.colorClass == 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content" :class="{ 'pulse-animation': value.id === 303 && value.status === 0 }"
                            :style="{ backgroundColor: value.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">
                            {{ value.id === 303 && value.status === 0 ? '响应文件' : value.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" alt="" class="stage-decoration hidden" />
                </div>
            </div>
            <!-- 第三阶段1： -->
            <div class="workflow-stage">
                <div class="workflow-item" v-for="value in resultStages1" :key="value.id"
                    @click="handleStageClick(value)" :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" alt="" class="stage-decoration hidden" />
                    <div>
                        <div class="stage-icon-content">
                            <img :src="hoveredStage === value.name ? require('@/assets/image/bidProProcess-hover-after.png') : (value.colorClass == 'teal' ? require('@/assets/image/bidProProcess-tow-after.png') : require('@/assets/image/bidProProcess-one-after.png'))"
                                class="stage-icon" />
                        </div>
                        <div class="content"
                            :style="{ backgroundColor: value.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">{{ value.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" alt="" class="stage-decoration hidden" />
                </div>
            </div>

            <!-- 创建一条虚线 -->
            <div class="workflow-line">
                <div class="workflow-line-item">
                    <span class="workflow-line-text">附加流程</span>
                </div>
            </div>
            <!-- 第四阶段 -->
            <div class="workflow-stage additional">
                <div class="workflow-item" v-for="value in endStages4" :key="value.id" @click="handleStageClick(value)"
                    :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" alt="" class="stage-decoration hidden" />
                    <div>
                        <div class="content"
                            :class="{ 'pulse-animation': value.id === 405 && hasUnreadChat }"
                            :style="{ backgroundColor: value.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">{{ value.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" alt="" class="stage-decoration hidden" />
                </div>
            </div>
            <!-- 第五阶段-->
            <div class="workflow-stage additional">
                <div class="workflow-item" v-for="value in endStages5" :key="value.id" @click="handleStageClick(value)"
                    :style="{ visibility: !value.visibility ? 'visible' : 'hidden' }">
                    <img src="@/assets/image/bidProProcess-two-left.png" alt="" class="stage-decoration hidden" />
                    <div>
                        <div class="content"
                            :style="{ backgroundColor: value.colorClass != 'teal' ? '#11c2eb' : '#0ed7c6' }"
                            @mouseenter="hoveredStage = value.name" @mouseleave="hoveredStage = null">{{ value.name }}
                        </div>
                    </div>
                    <img src="@/assets/image/bidProProcess-two-right.png" alt="" class="stage-decoration hidden" />
                </div>
            </div>
        </div>

        <!-- 聊天窗口组件 -->
        <ChatWindow :visible="chatWindowVisible" :position="chatWindowPosition" :current-user="currentUser"
            :chat-group-list="chatGroupList" :chat-messages="chatMessages" :default-group="chatGroupList[0] || {}"
            @close="handleChatWindowClose" @position-change="handleChatPositionChange" @send-message="handleSendMessage"
            @group-selected="handleGroupSelected" />

        <!-- 投标客户端下载弹窗 -->
        <el-dialog title="温馨提示:" :visible.sync="downloadDialogVisible" width="550px"
            custom-class="download-client-dialog">
            <div class="download-client-content">
                <div class="client-desc">
                    1、请使用投标客户端制作投标文件。<br />
                    2、投标所需工具可在首页下载中心中下载也可在此处下载
                </div>

                <table class="client-download-table">
                    <tbody>
                        <tr>
                            <td class="col-index">（一）</td>
                            <td class="col-title">投标客户端</td>
                            <td class="col-action">
                                <span class="download-link"
                                    @click="handleDownload('https://mfile.vbidding.com/public-downloads/ca/%E6%8A%95%E6%A0%87%E5%AE%A2%E6%88%B7%E7%AB%AF.exe')">下载</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="col-index">（二）</td>
                            <td class="col-title">ESSReader客户端</td>
                            <td class="col-action">
                                <span class="download-link"
                                    @click="handleDownload('https://mfile.vbidding.com/public-downloads/ca%2FESSPDFClient_SetupV4.5.4.rar')">下载</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="col-index">（三）</td>
                            <td class="col-title">证书应用环境安装程序</td>
                            <td class="col-action">
                                <span class="download-link"
                                    @click="handleDownload('https://mfile.vbidding.com/public-downloads/ca%2F%E8%AF%81%E4%B9%A6%E5%BA%94%E7%94%A8%E7%8E%AF%E5%A2%83%E5%AE%89%E8%A3%85%E7%A8%8B%E5%BA%8FV3.8.6(%E4%BF%A1%E6%AD%A5%E4%BA%91).zip')">下载</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="downloadDialogVisible = false" size="small">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import ChatWindow from '@/components/common/ChatWindow.vue'
import { getSubmitEndInfo } from '@/api/modules/base'
import { createPlatformServiceOrder } from '@/api/modules/tenderNotice'
import { getEvaluationRoomList, sendMessage, getChatList } from '@/api/modules/chat'
import { evaluationEndQuery } from '@/api/modules/evaluation'
import Cookies from 'js-cookie'
import { getUserInfo } from '@/api/modules/user'
import { getBidderFlowTitle } from '@/utils/bid/projectInfo'
import { getProjectInfo, getBidFlowStatus, getOpeningIsSubmit } from '@/api/modules/bidEvaluationCommittee'
import MQTT from '@/utils/network/mqtt'
import { mqttUrl } from '@/utils/base.js'
import { getBidSectionInfo } from '@/api/modules/bidEvaluationCommittee'

export default {
    name: 'BidderFlow',
    components: {
        ChatWindow
    },
    data() {
        return {
            bidSectionName: '',
            sectionCode: this.$route.query.sectionCode || '',
            hoveredStage: null,
            // 控制下载弹窗显示
            downloadDialogVisible: false,
            projectInfo: {
                projectCode: '',
                projectName: '',
            },
            projectTitle: '投标人流程——招标项目编号：　招标项目名称：',
            mainTitles: [
                {
                    id: 3,
                    name: '投标',
                    leftImage: require('@/assets/image/bidProProcess-one-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-one-right.png'),
                    colorClass: 'blue'
                },
                {
                    id: 4,
                    name: '开标',
                    leftImage: require('@/assets/image/bidProProcess-two-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-two-right.png'),
                    colorClass: 'teal'
                },
                {
                    id: 5,
                    name: '评标',
                    leftImage: require('@/assets/image/bidProProcess-one-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-one-right.png'),
                    colorClass: 'blue'
                },
                {
                    id: 6,
                    name: '定标',
                    leftImage: require('@/assets/image/bidProProcess-two-left.png'),
                    rightImage: require('@/assets/image/bidProProcess-two-right.png'),
                    colorClass: 'teal'
                }
            ],
            // 第一阶段
            mainStages: [
                // { id: 103, name: '下载招标文件', colorClass: 'blue', visibility: false, route: '/bidderHome/downloadTender' },
                // /bidderHome/makeBidDocument
                { id: 103, name: '制作投标文件', colorClass: 'blue', visibility: false, status: 1, route: '' },
                { id: 104, name: '开标大厅', colorClass: 'teal', visibility: false, route: '/openHall' },
                { id: 105, name: '解答评委疑问', colorClass: 'blue', visibility: false, route: '/bidderHome/answerJudges' },
                { id: 106, name: '查看中标候选人公示', colorClass: 'teal', visibility: false, route: '/bidderHome/viewWinBids' },
            ],
            // 第二阶段
            secondaryStages: [
                // { id: 203, name: '制作投标文件', colorClass: 'blue', visibility: false, route: '/bidderHome/makeBidDocument' },
                { id: 203, name: '缴纳技术服务费', colorClass: 'blue', visibility: false, status: 1, route: '/bidderHome/technologyFee' },
                { id: 204, name: '开标一览表', colorClass: 'teal', visibility: true, route: '/bidderHome/confirmBidRecord' },
                { id: 205, name: '', colorClass: 'blue', visibility: true, route: '' },
                { id: 206, name: '查看中标公告', colorClass: 'teal', visibility: false, route: '/bidderHome/checkNotice' },

            ],
            // 第三阶段
            resultStages: [
                { id: 303, name: '响应文件', colorClass: 'blue', visibility: false, status: 1, route: '/bidderHome/bidDocument' },
                { id: 304, name: '', colorClass: 'teal', visibility: true, route: '' },
                { id: 305, name: '', colorClass: 'blue', visibility: true, route: '' },
                { id: 306, name: '我的购标项目', colorClass: 'teal', visibility: true, route: '/bidderHome/myPurchaseProjects' }
            ],
            // 新增三阶段1
            resultStages1: [
                { id: 303, name: '响应文件', colorClass: 'blue', visibility: true, route: '/bidderHome/bidDocument' },
                { id: 304, name: '', colorClass: 'teal', visibility: true, route: '' },
                { id: 305, name: '', colorClass: 'blue', visibility: true, route: '' },
                { id: 306, name: '', colorClass: 'teal', visibility: true, route: '' }
            ],
            // 第四阶段
            endStages4: [
                { id: 403, name: '文件澄清与修改', colorClass: 'blue', visibility: false, route: '/bidderHome/bidClarification' },
                { id: 404, name: '', colorClass: 'teal', visibility: true, route: '' },
                { id: 405, name: '在线沟通', colorClass: 'blue', visibility: false, route: '' },
                { id: 406, name: '中标结果通知书', colorClass: 'teal', visibility: false, route: '/bidderHome/bidNoticeSuccessful' },
            ],
            // 第五阶段
            endStages5: [
                { id: 503, name: '文件质疑', colorClass: 'blue', visibility: false, route: '/bidderHome/raiseAQuestion' },
                { id: 504, name: '', colorClass: 'teal', visibility: true, route: '' },
                { id: 505, name: '二次报价', colorClass: 'blue', visibility: false, route: '/bidderHome/bidSecondQuotate' },
                { id: 506, name: '公示公告质疑', colorClass: 'teal', visibility: false, route: '/bidderHome/objectionManagement' },
            ],
            // 聊天相关数据
            chatWindowVisible: false,
            chatWindowPosition: { x: 100, y: 100 },
            hasUnreadChat: false,  // 未读消息标记
            currentUser: {
                name: '投标人:二公司',
                avatar: 'https://q3.itc.cn/q_70/images03/20250110/1e71eecf56b34344bcae6a5b85c0bec2.jpeg'
            },
            chatGroupList: [],
            chatMessages: [],
            selectedGroup: null,  // 当前选中的群组
            currentTopic: null    // 当前 MQTT 主题
        }
    },
    mounted() {
        if (this.sectionCode == '' || this.sectionCode == null) {
            this.sectionCode = localStorage.getItem('sectionCode')
        }
        this.getUserInfo()
        this.getProjectInfo()
        this.getBidFlowStatus()
        this.getBidSectionInfo()
        // 进入页面时自动初始化聊天监听（投标人只有一个群组）
        this.getEvaluationRoomList()

    },
    methods: {
        // 处理下载客户端
        handleDownloadClient() {
            const url = 'https://mfile.vbidding.com/public-downloads/ca/%E6%8A%95%E6%A0%87%E5%AE%A2%E6%88%B7%E7%AB%AF.exe'
            window.open(url, '_blank')
            this.downloadDialogVisible = false
        },
        // 统一处理下载文件链接
        handleDownload(url) {
            window.open(url, '_blank')
        },
        async getBidSectionInfo() {
            const res = await getBidSectionInfo(this.sectionCode)
            if (res.code == 200) {
                this.bidSectionName = res.data.bidSectionName
            } else {
                this.$message.error(res.msg)
            }
        },
        handleBack() {
            this.$router.go(-1)
        },
        getBidFlowStatus() {
            getBidFlowStatus({ sectionCode: this.sectionCode }).then(res => {
                if (res.code == 200) {
                    const { bidStatus, payStatus, echoStatus } = res.data || {}

                    // bidStatus: 1-已制作, 0-未制作
                    // 在 mainStages 中找到"制作投标文件"并设置 status
                    const makeBidDocStage = this.mainStages.find(stage => stage.id === 103)
                    if (makeBidDocStage) {
                        makeBidDocStage.status = bidStatus
                    }

                    // payStatus: 1-已缴费, 0-未缴费
                    // 在 secondaryStages 中找到"缴纳技术服务费"并设置 status
                    const payFeeStage = this.secondaryStages.find(stage => stage.id === 203)
                    if (payFeeStage) {
                        payFeeStage.status = payStatus
                    }

                    // echoStatus: 1-已上传响应文件, 0-未上传响应文件
                    // 在 resultStages 中找到"响应文件"并设置 status
                    const echoFileStage = this.resultStages.find(stage => stage.id === 303)
                    if (echoFileStage) {
                        echoFileStage.status = echoStatus
                    }
                } else {
                    this.$message.error(res.msg || '查询评标状态失败')
                }
            }).catch(error => {
                console.error('查询投标流程状态失败:', error)
            })
        },

        // 点击阶段
        handleStageClick(stage) {
            if (stage.id == 405) {
                // 显示聊天窗口（MQTT 已在页面加载时自动连接）
                this.chatWindowVisible = true
                this.hasUnreadChat = false  // 清除未读标记
                return
            }
            if (stage.id == 104) {
                this.GetOpeningIsSubmit(stage)
                return
            }
            if (stage.id == 303) {
                this.getCreatePlatformServiceOrderData(stage)

                return

            }
            if (stage.id == 103) {
                this.downloadDialogVisible = true
                return

            }
            if (stage.id == 103 || stage.id == 203 || stage.id == 303 || stage.id == 403 || stage.id == 503) {
                // 获取评标是否结束
                this.evaluationEndQuery(stage)
                return
            }
            if (stage.route) {
                this.navigateToStage(stage)
            }
        },
        // 获取订单信息
        getCreatePlatformServiceOrderData(stage) {
            createPlatformServiceOrder({
                sectionCode: this.sectionCode
            }).then(res => {
                if (res.code == 200) {
                    const data = res.data
                    if (data.status == 0 ) {
                        this.$message.error('未缴纳平台服务费')
                        return
                    }
                    this.getSubmitEndInfo(stage)
                }
            }).catch(error => {
                this.$message.error('获取订单信息失败')
            })
        },
        GetOpeningIsSubmit(stage) {
            getOpeningIsSubmit(this.sectionCode).then(res => {
                if (res.code == 200) {
                    if (res.data == false) {
                        this.$message.warning('未递交投标文件，提示请在响应文件处递交投标文件')
                        return
                    }
                    this.navigateToStage(stage)
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        navigateToStage(stage) {
            if (!stage.route) {
                this.$message.warning('当前流程节点暂未配置跳转页面')
                return
            }
            const targetRoute = {
                path: stage.route,
                query: {
                    sectionCode: this.sectionCode,
                    projectNumber: this.projectInfo.projectNumber,
                    projectCode: this.projectInfo.projectCode
                }
            }
            this.$router.push(targetRoute, () => { }, error => {
                if (error && error.name !== 'NavigationDuplicated') {
                    console.error('流程节点跳转失败:', error)
                    this.$message.error('页面跳转失败')
                }
            })
        },
        getSubmitEndInfo(stage) {
            getSubmitEndInfo(this.sectionCode).then(res => {
                if (res.code == 200) {
                    if (res.data == true) {
                        this.$message.error('已过递交文件截止时间')
                        return
                    }
                    this.navigateToStage(stage)
                } else {
                    this.$message.error(res.msg || '查询评标状态失败')
                }
            })
        },
        // 查询状态 
        evaluationEndQuery(stage) {
            evaluationEndQuery(this.sectionCode).then(res => {
                if (res.code == 200) {
                    if (res.data != null) {
                        const evaluationStatus = res.data.evaluationStatus
                        if (evaluationStatus == 0) {
                            this.navigateToStage(stage)
                        } else {
                            this.$message.error('评标已开始')
                            //   this.$router.push({ path: stage.route, query: { sectionCode: this.sectionCode, projectNumber: this.projectInfo.projectNumber, projectCode: this.projectInfo.projectCode } })
                        }
                    } else {
                        this.navigateToStage(stage)
                    }


                } else {
                    this.$message.error(res.msg || '查询评标状态失败')
                }
            })
        },
        // 获取聊天室列表
        async getEvaluationRoomList() {
            const res = await getEvaluationRoomList({ sectionCode: this.sectionCode })
            if (res.code === 200 && res.data && res.data.length > 0) {
                this.chatGroupList = res.data.map(item => ({
                    id: item.groupId,
                    name: item.groupName,
                    memberCount: item.memberCount,
                    memberList: item.memberList,
                    headImg: 'https://img1.baidu.com/it/u=2347178170,458451905&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500'
                }))

                // 默认选择第一个群组
                this.selectedGroup = this.chatGroupList[0]
                this.currentTopic = this.selectedGroup.id

                // 初始化 MQTT 连接
                this.initMqtt(this.currentTopic)

                // 获取历史聊天记录
                this.getChatList()
            } else {
                this.chatGroupList = []
            }
        },
        // 获取项目信息
        async getProjectInfo() {
            this.projectTitle = await getBidderFlowTitle(this.sectionCode);
            const res = await getProjectInfo(this.sectionCode)
            this.projectInfo = res.data
        },

        // 处理聊天窗口位置变化
        handleChatPositionChange(newPosition) {
            this.chatWindowPosition = newPosition
        },

        // 初始化 MQTT
        initMqtt(topic) {
            // 断开之前的连接
            MQTT.disconnect()
            // 随机数生成客户端 ID
            const clientId = Math.floor(Math.random() * 1000000000000000000)
            MQTT.connect(mqttUrl, {
                username: '',
                password: '',
                clientId: clientId,
                keepalive: 60,
                clean: true
            })
            // 监听连接成功
            MQTT.on('connect', () => {
                console.log('MQTT 连接成功')
            })
            // 订阅主题
            MQTT.subscribe(topic, (message) => {
                const msg = JSON.parse(message)
                // 投标人页面：senderType==0（专家）在左边，senderType==1（投标人自己）在右边
                const formattedMsg = {
                    id: msg.msgId,
                    type: msg.senderType === 1 ? 'own' : 'other',
                    content: msg.content,
                    senderType: msg.senderType,
                    senderName: msg.senderName,
                    createdTime: msg.createdTime
                }

                // 如果聊天窗口未打开，标记未读并显示通知
                if (!this.chatWindowVisible) {
                    this.hasUnreadChat = true
                    // 显示消息通知
                    this.$notify.info({
                        title: '有专家发来消息～',
                        message: msg.content
                    })
                }

                this.getChatList()
            }, { qos: 2 })

            // 监听错误
            MQTT.on('error', (err) => {
                console.error('MQTT 连接失败:', err)
            })
        },

        // 获取历史聊天记录
        async getChatList() {
            if (!this.currentTopic) return
            const res = await getChatList(this.currentTopic)
            if (res.code === 200 && res.data) {
                // 投标人页面：senderType==0（专家）在左边，senderType==1（投标人自己）在右边
                this.chatMessages = res.data.map(msg => ({
                    id: msg.msgId,
                    type: msg.senderType === 1 ? 'own' : 'other',
                    content: msg.content,
                    senderType: msg.senderType,
                    senderName: msg.senderName,
                    createdTime: msg.createdTime
                }))
            }
        },

        // 处理发送消息
        async handleSendMessage(newMessage) {
            if (!newMessage.content || !newMessage.content.trim()) return

            try {
                const res = await sendMessage({
                    groupId: this.currentTopic,
                    msg: newMessage.content,
                    userName: Cookies.get('userName') || this.currentUser.name,
                    msgType: 1
                })
                if (res.code === 200) {
                    this.getChatList()
                } else {
                    this.$message.error(res.msg || '发送消息失败')
                }
            } catch (error) {
                console.error('发送消息失败:', error)
                this.$message.error('发送消息失败')
            }
        },

        // 处理群组选择
        handleGroupSelected(group) {
            if (this.selectedGroup && this.selectedGroup.id === group.id) return
            this.selectedGroup = group
            this.currentTopic = group.id
            this.chatMessages = []
            // 重新初始化 MQTT 连接
            this.initMqtt(this.currentTopic)
            // 获取新群组的历史消息
            this.getChatList()
        },

        // 关闭聊天窗口
        handleChatWindowClose() {
            this.chatWindowVisible = false
        },
        // 获取用户信息
        getUserInfo() {
            getUserInfo().then(res => {
                if (res.code === 200) {
                    Cookies.set('roleId', res.data.roleId)
                    this.$store.commit('changedRoleId', res.data.roleId)
                }
            })
        },
    },

    // 组件销毁前清理 MQTT 连接
    beforeDestroy() {
        MQTT.disconnect()
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-flow-page {
    .apply-minimal-gray-theme();
}

// 页面头部
.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header-content {
    display: flex;
    flex-direction: column;
    text-align: start;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

.project-flow-toolbar {
    width: 100%;
    min-height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

// 工具栏操作区域样式
.toolbar-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.project-flow-toolbar__download-btn {
    // 下载按钮样式
}

.project-flow-toolbar__back {
    flex-shrink: 0;
}

.project-flow-toolbar__meta {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.project-flow-toolbar__title {
    margin: 0;
    color: @gray-700;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.4;
    text-align: center;
    word-break: break-word;
}

.project-flow-toolbar__section {
    display: inline-flex;
    align-items: center;
    align-self: center;
    max-width: 100%;
    padding: 8px 14px;
    border-radius: 999px;
    background: linear-gradient(90deg, rgba(17, 194, 235, 0.1) 0%, rgba(14, 215, 198, 0.12) 100%);
    border: 1px solid rgba(17, 194, 235, 0.18);
    box-sizing: border-box;
    gap: 10px;
}

.project-flow-toolbar__section-label {
    flex-shrink: 0;
    padding: 2px 10px;
    border-radius: 999px;
    background: linear-gradient(135deg, #11c2eb 0%, #0ed7c6 100%);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
}

.project-flow-toolbar__section-value {
    min-width: 0;
    color: @gray-700;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    word-break: break-word;
}

.project-flow-toolbar__code {
    display: inline-block;
    margin-left: 10px;
}

.project-flow-toolbar__back {
    flex-shrink: 0;
    margin-left: auto;
}

// 主要流程区域
.main-workflow {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 24px;
    background: #fff;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    overflow-x: auto;
    // margin-top: 20px;

    .workflow-stage {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
        gap: 16px;
        min-width: max-content;
        margin-top: 20px;

        &:first-child {
            margin-top: 0;
        }

        &.additional {
            margin-top: 16px;
        }

        .workflow-item {
            display: flex;
            align-items: center;
            height: 45px;
            flex-shrink: 0;
            cursor: pointer;
            transition: transform 0.2s ease;

            &:hover {
                transform: translateY(-2px);
            }

            .stage-decoration {
                height: 45px;
                width: auto;
                flex-shrink: 0;

                &.hidden {
                    visibility: hidden;
                }
            }

            .content-wrapper {
                position: relative;
                height: 45px;
                width: 200px;
                min-width: 180px;
                flex-shrink: 0;
            }

            .content {
                height: 45px;
                width: 200px;
                min-width: 180px;
                text-align: center;
                line-height: 45px;
                font-size: 14px;
                color: #fff;
                font-weight: 600;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                border-radius: 25px;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

                &:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                }
            }

            .pulse-animation {
                animation: pulse 2s ease-in-out infinite;
            }

            @keyframes pulse {

                0%,
                100% {
                    transform: scale(1);
                    box-shadow: 0 0 0 0 rgba(255, 77, 79, 0.4);
                }

                50% {
                    transform: scale(1.02);
                    box-shadow: 0 0 0 8px rgba(255, 77, 79, 0);
                }
            }

            .content-overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: transparent;
                z-index: 10;
                pointer-events: auto;
            }

            .stage-icon-content {
                width: 100%;
                display: flex;
                align-items: center;
                margin-bottom: 5px;

                .stage-icon {
                    margin: auto;
                    width: 14px;
                    height: 9px;
                }
            }
        }
    }

    // 主阶段特殊样式
    .main-stage {
        margin-bottom: 8px;

        .workflow-item {
            .content {
                border-radius: 4px;
                font-size: 15px;
            }
        }

        .decoration-image {
            height: 45px;
            width: auto;
            flex-shrink: 0;
        }
    }

    // 虚线样式
    .workflow-line {
        margin-top: 40px;
        margin-bottom: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        position: relative;

        .workflow-line-item {
            width: 100%;
            height: 2px;
            background: repeating-linear-gradient(to right,
                    @gray-400 0px,
                    @gray-400 10px,
                    transparent 10px,
                    transparent 20px);
            border-radius: 1px;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;

            .workflow-line-text {
                position: absolute;
                background-color: #fff;
                padding: 8px 20px;
                color: @gray-600;
                font-size: 14px;
                font-weight: 600;
                border-radius: 20px;
                white-space: nowrap;
                border: 1px solid @gray-200;
            }
        }
    }
}

// 下载弹窗样式
.download-client-content {
    padding: 10px;

    .client-desc {
        margin: 0 0 20px;
        font-size: 14px;
        color: #303133;
        line-height: 1.8;
        text-align: left;
        font-weight: 500;
    }

    .client-download-table {
        width: 100%;
        border-collapse: collapse;
        border: 1px solid #DCDFE6;
        margin-bottom: 10px;
        font-size: 14px;

        td {
            border: 1px solid #DCDFE6;
            padding: 10px 12px;
            height: 40px;
            box-sizing: border-box;
            vertical-align: middle;
        }

        .col-index {
            width: 70px;
            text-align: center;
            color: #606266;
            background-color: #fafafa;
        }

        .col-title {
            text-align: left;
            color: #303133;
            font-weight: 500;
        }

        .col-action {
            width: 80px;
            text-align: center;

            .download-link {
                color: #409EFF;
                cursor: pointer;
                font-weight: 500;
                text-decoration: underline;

                &:hover {
                    color: #66b1ff;
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .bidder-flow-page {
        padding: 16px;
    }

    .project-flow-toolbar {
        flex-direction: column;
        align-items: stretch;
        min-height: auto;
    }

    .project-flow-toolbar__title {
        font-size: 18px;
        text-align: center;
    }

    .project-flow-toolbar__section {
        width: 100%;
        border-radius: 16px;
        align-items: flex-start;
        flex-direction: column;
        gap: 8px;
    }

    .project-flow-toolbar__section-label {
        line-height: 18px;
    }

    .project-flow-toolbar__code {
        display: block;
        margin-left: 0;
        margin-top: 6px;
    }

    .project-flow-toolbar__back {
        margin-left: 0;
        align-self: flex-start;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
    }

    .page-title {
        font-size: 20px;
    }

    .main-workflow {
        padding: 16px;

        .workflow-stage {
            gap: 12px;
        }
    }
}
</style>

<!-- 非 scoped 样式，用于自定义 el-dialog 的一些全局样式覆盖 -->
<style lang="less">
.download-client-dialog {
    .el-dialog__header {
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 15px;
    }

    .el-dialog__body {
        padding: 20px;
    }
}
</style>
